import { Chip } from '@mui/material'
import PauseCircleFilledRoundedIcon from '@mui/icons-material/PauseCircleFilledRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import PrintRoundedIcon from '@mui/icons-material/PrintRounded'
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded'
import DirectionsRunRoundedIcon from '@mui/icons-material/DirectionsRunRounded'
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded'
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import LockRoundedIcon from '@mui/icons-material/LockRounded';

const Ordered = <Chip
    icon={<PauseCircleFilledRoundedIcon />}
    label="Megrendelve"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#6c757d',
        borderColor: '#6c757d',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

const Confirmed = <Chip
    icon={<CheckCircleRoundedIcon />}
    label="Megerősítve"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#007bff',
        borderColor: '#007bff',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

const Packaging = <Chip
    icon={<PrintRoundedIcon />}
    label="Összekészítésre vár"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#17a2b8',
        borderColor: '#17a2b8',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

const Delivering = <Chip
    icon={<LocalShippingRoundedIcon />}
    label="Kiszállításra vár"
    variant="outlined"
    sx={{
        color: '#212529',
        backgroundColor: '#ffc107',
        borderColor: '#ffc107',
        '& .MuiChip-icon': {
            color: '#212529',
        },
    }}
/>

const Out = <Chip
    icon={<DirectionsRunRoundedIcon />}
    label="Kint"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#6610f2',
        borderColor: '#6610f2',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

const Returned = <Chip
    icon={<ReplayRoundedIcon />}
    label="Visszaszállított"
    variant="outlined"
    sx={{
        color: '#212529',
        backgroundColor: '#fd7e14',
        borderColor: '#fd7e14',
        '& .MuiChip-icon': {
            color: '#212529',
        },
    }}
/>

const Closed = <Chip
    icon={<LockRoundedIcon />}
    label="Lezárva"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#e6222d',
        borderColor: '#e6222d',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

const Invalid = <Chip
    icon={<CancelRoundedIcon />}
    label="Érvénytelenítve"
    variant="outlined"
    sx={{
        color: '#fff',
        backgroundColor: '#dc3545',
        borderColor: '#dc3545',
        '& .MuiChip-icon': {
            color: '#fff',
        },
    }}
/>

export {
    Ordered,
    Confirmed,
    Packaging,
    Delivering,
    Out,
    Returned,
    Closed,
    Invalid,
}
